module.exports = __webpack_public_path__ + "a483b974533869581d9128cad573c42d.pdf";